<template>
  <div :class="['topbar', {'topbar_center': !isAuth}]">
    <div class="topbar__title"
          v-if="isAuth && isMobileDevice && titleHeader">
      <span class="icon icon-arrow-nav"
            @click="$router.push('/home')"></span>
      <div class="label">{{ titleHeader }}</div>
    </div>

    <router-link v-else
                  :to="isMobileDevice ? '/home' : '/statistics'">
      <img class="topbar__img_company"
            src="@/assets/img/logo-wifi.svg"
            alt="Логотип WiFi Бизнес от Уфанет">
    </router-link>

    <el-dropdown v-if="isAuth"
                  class="topbar__dropdown dropdown"
                  trigger="click"
                  @visible-change="isOpenedDropdown = !isOpenedDropdown">
      <span :class="[{'dropdown__toggle_opened': isOpenedDropdown}, 'el-dropdown-link dropdown__toggle']">
        <span class="label">Профиль</span>
        <span class="icon icon-arrow"></span>
      </span>
      <el-dropdown-menu slot="dropdown"
                        class="dropdown__menu">
        <li class="dropdown__menu__user">{{$store.state.user.username}}</li>
        <el-dropdown-item class="dropdown__menu__item dropdown__menu__item_logout"
                          @click.native="logout">Выйти</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
/**
 *  Компонент верхней панели.
 */
export default {
  name: 'Topbar',
  data () {
    return {
      /**
       *  Используется для добавления класса элементу.
       *  @type {Boolean}
       */
      isOpenedDropdown: false,
      /**
       *  Заголовок текущей страницы в шапке. Значение устанавливается в конфигах роутинга.
       *  @type {String}
       */
      titleHeader: null
    }
  },
  created () {
    this.$router.afterEach((to, from) => {
      this.titleHeader = to.meta.titleHeader
    })
  },
  mounted () {
    this.watchDeviceWidth()
  },
  computed: {
    /**
     *  Показываем меню настроек только когда пользователь авторизован.
     *  @returns {Boolean}
     */
    isAuth () {
      return this.$store.state.user.isAuth
    }
  },
  methods: {
    /**
     *  Выход из системы, очищаем локальное хранилище браузера.
     *  @returns  {Undefined}
     */
    logout () {
      this.$store.commit('LOGOUT')
      this.$router.push('/auth')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Topbar.vue